import { render, staticRenderFns } from "./AddPickupModal.vue?vue&type=template&id=492ef555&"
import script from "./AddPickupModal.vue?vue&type=script&lang=js&"
export * from "./AddPickupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports